<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ isEdit ? 'Edit' : 'Add' }} PT Commission Setting
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/ptReport/ptCommissionSetting/index')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateSubmit">
              <div class="mb-10 text-left">
                <div class="mb-5">Personal Trainer</div>
                <b-form-select name="personal_trainer" v-validate="'required'" :disabled="isEdit" v-model="addData.personal_trainer_id" class="form-control">
                  <option :value="null">Please select</option>
                  <option v-for="item in listPersonalTrainer" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
                <span class="error">{{ errors.first('personal_trainer') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Pakai Cap Club Achievement?</div>
                <b-form-radio-group v-model="addData.use_club_achievement">
                  <b-form-radio :value="true">Ya, ikut aturan cap achievement (default)</b-form-radio>
                  <b-form-radio :value="false">Tidak, exclude — pakai flow lama (murni tier volume)</b-form-radio>
                </b-form-radio-group>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Note</div>
                <b-form-textarea v-model="addData.note" name="note" rows="3"></b-form-textarea>
              </div>
              <div class="text-right">
                <button class="btn-primary pt-5 pb-5">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ptCommissionSettingAdd',
  data: function () {
    return {
      isEdit: false,
      listPersonalTrainer: [],
      addData: {
        personal_trainer_id: null,
        use_club_achievement: false,
        note: ''
      }
    }
  },
  methods: {
    validateSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put('crm/v1/pt_commission_setting/' + this.addData.personal_trainer_id, {
            use_club_achievement: this.addData.use_club_achievement,
            note: this.addData.note
          }).then(() => {
            this.$router.push('/ptReport/ptCommissionSetting/index')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData () {
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc').then(response => {
        this.listPersonalTrainer = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      if (this.$route.query.id) {
        this.isEdit = true
        axios.get('crm/v1/pt_commission_setting/' + this.$route.query.id).then(response => {
          if (response.data.data) {
            this.addData.personal_trainer_id = response.data.data.personal_trainer_id
            this.addData.use_club_achievement = response.data.data.use_club_achievement
            this.addData.note = response.data.data.note
          }
        }).catch(error => {
          console.log('error', error)
        })
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
